import { phoneNumberValidation } from 'utils/phoneNumberValidation';

function phoneNumberMeetsConditions(phoneNumber) {
  return !phoneNumber || phoneNumber.length <= 1 || typeof phoneNumber !== 'string';
}

function isInvalidPair(phoneNumber, phoneCountry) {
  return phoneNumber[0] !== '+' && (!phoneCountry || Object.keys(phoneCountry).length === 0);
}

function prepareValueForValidation(value) {
  return !value.startsWith('+') ? `+${value}` : value;
}

export default function isPhoneNumberValid(value, country) {
  if (phoneNumberMeetsConditions(value)) return true;

  if (isInvalidPair(value, country)) return false;

  return phoneNumberValidation(prepareValueForValidation(value), country);
}
